// @ts-nocheck

import { Block } from "@xprog/prensa"

import * as S from '../styles'

const CbngoPageTeam = () => {
  return (
    <S.MainDiv>
      <S.Heading1>Expediente</S.Heading1>
      <Block css={S.logoProps}>
        <img src='/assets/opopular/logos/LogoGrupoJaimeCamara.svg' alt='Logo Grupo Jaime Câmara' height='32px' width='110px' />
      </Block>
      <Block css={S.topBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>FUNDADOR:</S.Heading2>
          <S.Heading3>Jaime Câmara (1909 - 1989)</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>VICE-PRESIDENTE DE NEGÓCIOS:</S.Heading2>
          <S.Heading3>Ronaldo Borges Ferrante</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>PRESIDENTE:</S.Heading2>
          <S.Heading3>Jaime Câmara Júnior</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>CEO:</S.Heading2>
          <S.Heading3>Breno Machado</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>DIR. JURÍDICO/ REL. INSTITUCIONAIS:</S.Heading2>
          <S.Heading3>Guliver Augusto Leão</S.Heading3>
        </Block>
      </Block>
      <Block css={S.logoProps}>
        <img src='/assets/cbngo/logos/LogoCBNDesktop.svg' alt='Logo cbngo Goiânia' height='102px' width='182px' />
      </Block>
      <Block css={S.topBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>Coordenação de Jornalismo</S.Heading2>
          <S.Heading3>Luiz Geraldo</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Gerente de Conteúdo Digital</S.Heading2>
          <S.Heading3>Elisângela Nascimento</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Apresentação CBN Goiânia</S.Heading2>
          <S.Heading3>Luiz Geraldo</S.Heading3>
          <S.Heading3>Daniela Versiane</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Apresentação Tarde CBN</S.Heading2>
          <S.Heading3>Nathália Lima</S.Heading3>
          <S.Heading3>José Bonfim</S.Heading3>
        </Block>
      </Block>
      <Block css={S.middleBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>Produção</S.Heading2>
          <S.Heading3>Andressa Vasconcelos</S.Heading3>
          <S.Heading3>Laylla Alves</S.Heading3>
          <S.Heading3>Maísa Martins</S.Heading3>
          <S.Heading3>Déborah Marques</S.Heading3>
          <S.Heading3>Gracielly Oliveira</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Editores Digital</S.Heading2>
          <S.Heading3>Paula Resende</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Reportagem</S.Heading2>
          <S.Heading3>Sabrina Vilela</S.Heading3>
          <S.Heading3>Eliara Salla</S.Heading3>
          <S.Heading3>Anna Clelma</S.Heading3>
        </Block>
      </Block>
    </S.MainDiv>
  )
}

export default CbngoPageTeam
